import {ChangeDetectorRef, Component, NgZone, ViewChild} from '@angular/core';
import {
  AlertController,
  Content,
  IonicPage,
  Loading,
  LoadingController,
  NavController,
  NavParams,
  Platform,
  Popover,
  PopoverController, TextInput
} from 'ionic-angular';
import {TranslateService} from "@ngx-translate/core";
import {AppConfigPage} from "../app-config/app-config";
import {VizixService} from "../../providers/vizix.service";
import {ReportDefinitionResponse} from "vizixc/dist";
import {ProductStatus} from "../../models/change-status/productStatus";
import {isUndefined} from "ionic-angular/util/util";
import {ListFormProperty} from "vizixc/dist/interfaces/report.list.property.interface";
import {PopoverProductStatusPage} from "../popover-product-status/popover-product-status";
import {ReportProperty} from "vizixc/dist/interfaces/report.property.interface";
import {PatchThingRequestItem} from "../../models/PatchThingRequestItem";
import {ReaderService} from "../../providers/reader.service";
import {ValidateChangeStatusFieldPipe} from "../../pipes/validate-tag/validate-change-status-field";
import {FormatDataTypePipe} from "../../pipes/format-data-type/format-data-type";
import {Observer} from "rxjs/Observer";
import {Observable} from "rxjs/Observable";
import {
  ITEM_EVENT_CHANGE_STATUS,
  ITEM_UDF_ACTIVITY,
  ITEM_UDF_CATEGORY,
  ITEM_UDF_SOURCE,
  ITEM_UDF_SUB_CATEGORY,
  ITEM_UDF_USER,
  ITEM_UDF_UUID_MOBILE,
  NAV_PARAM_RETURN_PAGE,
  READER_TYPE_BARCODE,
  RETURN_PAGE_CHANGE_STATUS, VALIDATION_INPUT_TAG,
  VIZIX_EVENT_ID_CHANGE_STATUS,
  VIZIX_THING_ITEM_UDF_SOURCE,
  VizixEventActivity,
  VizixEventCategory,
  VizixEventEventType,
  VizixEventSubCategory
} from "../../app/app.constants";
import {Subscription} from "rxjs/Subscription";
import {Keyboard} from "@ionic-native/keyboard";
import {ReportEntryProperty} from "vizixc/dist/interfaces/report.entry.property.interface";
import {VizixEventService} from "../../providers/vizix.event.service";

/**
 * Generated class for the ChangeStatusPage page.
 *
 * See http://ionicframework.com/docs/components/#navigation for more info
 * on Ionic pages and navigation.
 */

@IonicPage()
@Component({
  selector: 'page-change-status',
  templateUrl: 'change-status.html',
  providers: [ValidateChangeStatusFieldPipe, FormatDataTypePipe]
})
export class ChangeStatusPage {

  private tag = '[CHANGE_STATUS]';

  public dataFields: any = [];
  public arrayStatus: ProductStatus[] = [];
  public dataTypes: any[] = []; // [{name: UDF, dataTypeId: 13}]
  public reportProperties: ReportProperty[] = [];
  public result: any;
  private loading: Loading;
  private popover: Popover;
  private currentStatus: ProductStatus;
  public currentTag: string = '';
  private shouldGetSOH = false;
  private toSearchValue = '';
  public isCameraEnabled = false;
  public isBarcodeMode = false;
  is_loading: boolean = false;
  is_alert: boolean = false;

  @ViewChild(Content) content: Content;
  @ViewChild('inputItem') inputTagField: TextInput;
  public isKeyboardOpen: boolean = false;
  private keyboardHideSubscription: Subscription;
  private itemStatusUDF: string;
  private reportEntryPropertyList: ReportEntryProperty[];

  private thingTypeCode: string;
  private thingTypeCodeGroup: string;
  private username: string;
  private uuid: string;
  private barcodeAttempts = 0;
  private isPopActive: boolean = false;
  private DidPageLoad: boolean = false;

  public inputError: string = '';
  private inputErrorTimeout: any;
  private validationExpRegTagWithoutQuantifiers;

  constructor(public navCtrl: NavController,
              public navParams: NavParams,
              public translate: TranslateService,
              public _vizixService: VizixService,
              private loadingCtrl: LoadingController,
              private popoverCtrl: PopoverController,
              public readerService: ReaderService,
              public alertCtrl: AlertController,
              private cdr: ChangeDetectorRef,
              private validateChangeStatusField: ValidateChangeStatusFieldPipe,
              private formatDataTypePipe: FormatDataTypePipe,
              private platform: Platform,
              private ngZone: NgZone,
              private keyboard: Keyboard,
              private vizixEventService: VizixEventService) {

    // Initialize empty until we get the item information
    this.currentStatus = new ProductStatus();
    this.currentStatus.name = "";
    this.validationExpRegTagWithoutQuantifiers = this._vizixService.removeQuantifiersOfRegularExpression(this._vizixService.configurationApp.ChangeStatusConfiguration.FieldValidation.value);
  }

  openPopover(event) {
    // Open only if the current item is not null
    if (this.currentTag != null && this.currentTag != '' && this.dataFields.length > 0) {
      this.popover.present({ev: event}); // Without event, the popoverDetails shows in the middle
      this.popover.onWillDismiss(data => {
        if (data != null) {
          console.log(this.tag, data);
          this.switchStatus(data);
        }
      })
    }
  }

  ionViewWillEnter() {
  }

  ionViewDidEnter() {
    this.content.resize();

    if (this.arrayStatus.length > 0) {

      if (!this.DidPageLoad) {
        this.showLoadingInitializingReader();
      }

      if (this.isBarcodeMode) {
        this.changeBarcodeMode();
      }
      else {
        this.changeRFIDMode();
      }
      if (!this.DidPageLoad) {
        this.dismissLoading();
      }
    }
    this.DidPageLoad = false;
    this.cdr.reattach();
    this.cdr.detectChanges();

    this.platform.registerBackButtonAction(() => {
      this.goBack();
    });
  }

  showLoadingInitializingReader() {

    if (!this.loading) {
      this.loading = this.loadingCtrl.create({
        content: this.translate.instant('change_status.loadings.initializing_scanner')
      });

      this.is_loading = true;
      console.log(this.tag, "IS DIALOG  INITIALIZING READER SHOWING");
      console.log(this.tag, true);
      this.loading.present();
    }
  }

  ionViewDidLoad() {
    console.log(this.tag, 'ionViewDidLoad ChangeStatusPage');
    this.DidPageLoad = true;
    // this.isCameraEnabled = this.simulatorService.isSimulatorEnabled && this.platform.is('cordova');
    //AS AN OBSERVATION CANERA WOULD NOT APPEAR IN THIS MODULE
    //this.isCameraEnabled = this.platform.is('cordova');

    this.keyboard.onKeyboardShow().subscribe(() => {
      this.isKeyboardOpen = true;
    });

    this.keyboard.onKeyboardHide().subscribe(() => {
      this.isKeyboardOpen = false;
    });

    // Initialize loading dialog
    this.loading = this.loadingCtrl.create({
      content: 'Please Wait'
    });
    this.is_loading = true;
    this.loading.present();

    // Get the username and uuid, possibly other values, to send to patchItem
    this.vizixEventService.getVizixEventItemBase().then((event) => {
      this.username = event.user;
      this.uuid = event.remoteSource;
    });

    this._vizixService.VizixGetReportDefinitionChangeStatus().subscribe(
      (reportDefinitionResponse: ReportDefinitionResponse) => {

        if (reportDefinitionResponse &&
          reportDefinitionResponse.getReportEntryOption() &&
          reportDefinitionResponse.getReportEntryOption().length > 0 &&
          reportDefinitionResponse.getReportEntryOption()[0].reportEntryOptionProperty &&
          reportDefinitionResponse.getReportEntryOption()[0].reportEntryOptionProperty.length > 0 &&
          reportDefinitionResponse.getReportEntryOption()[0].reportEntryOptionProperty[0].entryFormPropertyData &&
          reportDefinitionResponse.getReportEntryOption()[0].reportEntryOptionProperty[0].entryFormPropertyData.length > 0 &&
          reportDefinitionResponse.getReportProperty()) {
          // Here we get the status list, but it doesn't have the colors or positions, so we get these values with another request
          let vizixStatusList: Array<ListFormProperty> = reportDefinitionResponse.getReportEntryOption()[0].reportEntryOptionProperty[0].entryFormPropertyData;

          // Get the report properties, to link the label and the udf
          this.reportProperties = reportDefinitionResponse.getReportProperty();
          this.reportEntryPropertyList = reportDefinitionResponse.getReportEntryOption()[0].reportEntryOptionProperty;
          this.thingTypeCode = 'Item';

          // Update the ThingTypeCodeGroup value
          this.updateThingTypeCodeGroup();

          this.itemStatusUDF = reportDefinitionResponse.getReportEntryOption()[0].reportEntryOptionProperty[0].propertyName;
          console.log(this.tag, 'Item Status UDF', this.itemStatusUDF);

          // First we get only the serial numbers
          let productStatusSerialList: string[] = [];
          for (let listFormProperty of vizixStatusList) {
            productStatusSerialList.push(listFormProperty.value);
          }

          // Now we get the data types for the fields for Item thing type
          this._vizixService.VizixGetDataType(this._vizixService.configurationApp.AppParametersConfiguration.ThingTypeCodeItem.value).subscribe((response: any[]) => {
              this.dataTypes = response;
              console.log(this.tag, 'DataTypes:', this.dataTypes);

              // Now we get the Product Status objects for the serial numbers on the data entry
              this._vizixService.VizixGetProductStatusColor(productStatusSerialList).subscribe((statusList: ProductStatus[]) => {
                  console.log(this.tag, 'getProductStatusColorResponse');
                  console.log(this.tag, statusList);
                  this.arrayStatus = statusList;

                  this.initReader();

                  this.initPopover(this.currentStatus);

                  this.dismissLoading();

                }, (error) => {
                  console.log(this.tag, 'error', error);
                  this.dismissLoading();
                  this.showErrorAlert();
                }
              );

            }, (error) => {
              console.log(this.tag, 'error', error);
              this.dismissLoading();
              this.showErrorAlert();
            }, () => {
              console.log(this.tag, 'complete');
            }
          );
        } else {
          this.showErrorReportAlert();
        }

      },
      (error: any) => {
        console.log(this.tag, 'error', error);
        this.showErrorAlert();

      }, () => {

      }
    );
  }

  initReader() {
    // Initialize Reader in isCycleCountScreenShowing mode
    console.log(this.tag, 'Reader Type', this._vizixService.configurationApp.ChangeStatusConfiguration.FieldReaderType.value);

    if (this._vizixService.configurationApp.ChangeStatusConfiguration.FieldReaderType.value == READER_TYPE_BARCODE) {
      console.log(this.tag, 'Reader set to BARCODE');
      this.isBarcodeMode = true;
      this.changeBarcodeMode();
    } else {
      console.log(this.tag, 'Reader set to RFID');
      this.isBarcodeMode = false;
      this.changeRFIDMode();
    }
  }

  ionViewWillLeave() {
    this.stopReader();
    this.cdr.detach();
  }

  /*
   * Method that changes configuration to barcode when radio button value=barcode
   */
  changeBarcodeMode() {
    this.readerService.isConnected().subscribe((isConnected) => {
      if (isConnected) {
        this.readerService.initBarcodeScan().subscribe(
          (result) => {
            this.barcodeAttempts = 0;
            console.log(this.tag, 'BARCODE response', result);
            console.log(this.tag, result);
            if (result.value != null) {
              this.showTagScanned(result.value);
            }
          },
          (e) => {
            console.log(this.tag, 'error');
            console.log(this.tag, e);

            if (e.code == 800 && this.barcodeAttempts <= 3) {
              this.barcodeAttempts++;
              setTimeout(() => {
                this.changeBarcodeMode();
              }, 500);
            }
          }
        );
      }
    });
  }

  openBarcodeCamera() {
    this.readerService.initBarcodeCameraScan().then((barcode) => {
      this.showTagScanned(barcode.value);
    }, (error) => {
      console.log(this.tag, 'Error barcode camera', error);
    });
  }

  /*
   * Method that changes configuration to rfid when radio button value=rfid
   */
  changeRFIDMode() {
    this.readerService.isConnected().subscribe((isConnected) => {
      if (isConnected) {

        this.readerService.initSingleScan().subscribe(
          (response) => {
            if (this.inputErrorTimeout) {
              clearTimeout(this.inputErrorTimeout);
              this.inputErrorTimeout = null;
            }
            this.inputError = '';

            // Tag read
            console.log(this.tag, 'Single Tag response', response.value);
            if (response.value === '3001') {
              this.clearScreen(true, true);
              this.ngZone.run(() => {
                this.inputError = 'tooManyTagsFound';
              });
              this.inputErrorTimeout = setTimeout(() => {
                this.ngZone.run(() => {
                  this.inputError = '';
                })
              }, 3000);
            } else {
              this.showTagScanned(response.value);
            }
          },
          (error) => {
            console.log(this.tag, 'ERROR', error);
          }
        );
      }
    });
  }

  // Called every time we do a reader operation
  isReaderConnected(): Observable<any> {
    return Observable.create((observer: Observer<any>) => {
      this.readerService.isConnected().subscribe(
        (result) => {
          console.log(this.tag, "Reader is connected", result);
          if (result) {
            observer.next(true); // Connected
          } else {
            observer.error("Reader not connected"); // Not connected
          }
        },
        (error) => {
          observer.error("Reader not connected"); // Not connected
        }
      );
    });
  }

  stopReader() {
    this.isReaderConnected().subscribe(() => {
      if (this.platform.is('cordova')) {
        this.readerService.stopScanCC().subscribe(
          () => {
            console.log(this.tag, 'Reader stopped successfully');
          },
          (error) => {
            console.log(this.tag, 'Error stopping reader', error);
          }
        );
      }
    }, (error) => {
      console.log(this.tag, 'ERROR', error);
    });
  }

  showTagScanned(tag: string) {
    if (!this.is_alert) {
      this.currentTag = tag.toUpperCase();
      this.cdr.detectChanges();
      this.lookupAndHideKeyboard(this.currentTag);
    }
  }

  initPopover(status: ProductStatus) {
    // Initialize popoverDetails with the new product status list and the current status
    this.popover = this.popoverCtrl.create(PopoverProductStatusPage,
      {
        'statusList': this.arrayStatus,
        'selectedStatus': status
      });
  }

  lookupAndHideKeyboard(tag: string) {
    if (this.platform.is('cordova') && this.isKeyboardOpen) {
      this.keyboard.close();
      this.keyboardHideSubscription = this.keyboard.onKeyboardHide().subscribe(() => {
        this.isKeyboardOpen = false;
        this.lookupTag(tag);
        this.keyboardHideSubscription.unsubscribe();
      });
    } else {
      this.lookupTag(tag);
    }
  }

  lookupTag(tag: string) {
    tag = tag.toUpperCase().trim();

    if (tag && tag.length) {
      this.shouldGetSOH = false;
      this.toSearchValue = '';

      if (this.validateChangeStatusField.transform(tag)) {

        this.showLoading();

        this.currentTag = tag;
        console.log(this.tag, 'looking up tag ' + tag);
        this.dataFields = [];

        if (this.arrayStatus.length > 0) {
          this._vizixService.VizixPostReportExecutionChangeStatus({"RFID": tag}).subscribe(
            (data: any) => this.result = data,
            err => {
              console.log(this.tag, 'error', err);
              this.showErrorAlert();
            },
            () => {
              if (this.loading) {

                this.dismissLoading();
              }
              if (isUndefined(this.result.results[0]) && this.result.results.length == 0) {
                this.showErrorNotFound(tag);
                this.dataFields = [];
              }
              else {
                let response: any = this.result.results[0];
                console.log(this.tag, response);

                this.reportProperties.forEach((reportProperty, index) => {
                  let label: string = reportProperty.label;
                  let value: any = response[label];
                  // Here we filter the default fields returned by the report
                  if (label != this._vizixService.configurationApp.ChangeStatusConfiguration.ProductStatusLabelReport.value
                    && label != 'thingTypeId' && label != 'thing.headers' && label != 'id') {
                    this.dataFields.push({"label": label, "value": this.formatDataType(label, value)});
                  }
                  // Product status is returned by the report, so we show the corresponding Product Status object
                  if (label == this._vizixService.configurationApp.ChangeStatusConfiguration.ProductStatusLabelReport.value) {
                    let status: ProductStatus = new ProductStatus();
                    status.name = value;
                    status.color = "#dddddd";
                    this.currentStatus = status;

                    // We get the Status label, so we find the Product Status object to show
                    for (let status of this.arrayStatus) {
                      if (status.name == value) {
                        this.currentStatus = status;
                        break;
                      }
                    }
                    this.initPopover(this.currentStatus);
                  }
                });
              }

              // Get the value to send to the other Report
              for (let dataField of this.dataFields) {
                if (dataField.label == this._vizixService.configurationApp.IdentifyItemConfiguration.FieldValueSOH.value) {
                  this.shouldGetSOH = true;
                  this.toSearchValue = String(dataField.value);
                }
              }

              // Once complete, we execute the Report for SOH only if the SKU is present
              if (this.shouldGetSOH) {
                console.log(this.tag, 'Executing SOH Report for ' + this._vizixService.configurationApp.IdentifyItemConfiguration.FieldValueSOH.value + ': ' + this.toSearchValue);
                let filtersJson = {};
                filtersJson[this._vizixService.configurationApp.IdentifyItemConfiguration.FilterLabelSOHSerial.value] = String(this.toSearchValue);
                filtersJson[this._vizixService.configurationApp.IdentifyItemConfiguration.FilterLabelSOHStoreID.value] = String(this._vizixService.getStoreId());
                console.log(this.tag, 'Filters JSON:');
                console.log(this.tag, filtersJson);
                this._vizixService.VizixPostReportExecutionSOH(filtersJson).subscribe(
                  (data: { label: string, qty: number }) => {
                    this.dataFields.push({"label": data.label, "value": this.formatDataType(data.label, data.qty)});
                    // Now add the label:value from this report
                    this.cdr.detectChanges();
                  },
                  err => {
                    console.log(this.tag, 'error', err);
                    this.showErrorAlert();
                  }
                );
              } else {
                console.log(this.tag, 'Report SOH label not found.. looking for label: ' + this._vizixService.configurationApp.IdentifyItemConfiguration.FieldValueSOH.value);
              }

              this.cdr.detectChanges();
            }
          );
        } else {
          this.showErrorReportAlert();
        }

      } else {
        this.showErrorInvalid();
      }
    }
  }

  showLoading() {

    if (!this.loading) {
      this.loading = this.loadingCtrl.create({
        content: this.translate.instant('change_status.alerts.looking_up_item.message')
      });

      this.is_loading = true;
      console.log(this.tag, "IS DIALOG SHOWING");
      console.log(this.tag, true);
      this.loading.present();
    }
  }

  /*
  custom dialog dismiss
   */
  dismissLoading() {
    this.is_loading = false;
    if (this.loading) {
      this.loading.dismiss();
      this.loading = null;
    }
  }


  showErrorNotFound(tagID) {
    if (!this.is_alert) {

      let alert = this.alertCtrl.create({
        title: this.translate.instant('change_status.alerts.dialog_item_lookup.invalid'),
        message: this.translate.instant('change_status.alerts.dialog_item_lookup.unable_to_find') + " " + tagID,
        enableBackdropDismiss: false,
        buttons: [
          {
            text: this.translate.instant('change_status.alerts.dialog_item_lookup.ok'),
            handler: () => {

              this.is_alert = false;
              console.log(this.tag, 'Ok clicked');
            }
          }

        ]
      });

      this.is_alert = true;

      alert.onDidDismiss(() => {
        this.is_alert = false;
      });

      alert.present();
    }
  }

  showErrorInvalid() {
    if (!this.is_alert) {

      let alert = this.alertCtrl.create({
        title: this.translate.instant('change_status.alerts.dialog_item_lookup.invalid'),
        enableBackdropDismiss: false,
        buttons: [
          {
            text: this.translate.instant('change_status.alerts.dialog_item_lookup.ok'),
            handler: () => {

              this.is_alert = false;
              console.log(this.tag, 'Ok clicked');
            }
          }

        ]
      });

      this.is_alert = true;

      alert.onDidDismiss(() => {
        this.is_alert = false;
      });

      alert.present();
    }
  }

  showSuccessAlert() {
    if (!this.is_alert) {

      let alert = this.alertCtrl.create({
        title: this.translate.instant('change_status.alerts.change_status_success.title'),
        enableBackdropDismiss: false,
        buttons: [
          {
            text: this.translate.instant('change_status.alerts.change_status_success.ok'),
            handler: () => {

              this.is_alert = false;
              console.log(this.tag, 'Ok clicked');
            }
          }

        ]
      });

      alert.onDidDismiss(() => {
        this.is_alert = false;
      });

      this.is_alert = true;
      alert.present();
    }
  }

  showErrorAlert() {
    if (!this.is_alert) {

      let alert = this.alertCtrl.create({
        title: this.translate.instant('change_status.alerts.change_status_failure.title'),
        message: this.translate.instant('change_status.alerts.change_status_failure.message'),
        enableBackdropDismiss: false,
        buttons: [
          {
            text: this.translate.instant('change_status.alerts.change_status_failure.ok'),
            handler: () => {
              this.clearScreen(false, true);
              this.is_alert = false;
            }
          }

        ]
      });

      alert.onDidDismiss(() => {
        this.is_alert = false;
      });

      this.is_alert = true;
      alert.present();
    }
  }

  showErrorReportAlert() {
    if (!this.is_alert) {

      let alert = this.alertCtrl.create({
        title: this.translate.instant('change_status.alerts.report_error.title'),
        message: this.translate.instant('change_status.alerts.report_error.message'),
        enableBackdropDismiss: false,
        buttons: [
          {
            text: this.translate.instant('change_status.alerts.report_error.ok'),
            handler: () => {
              this.clearScreen(false, true);
              this.is_alert = false;
            }
          }

        ]
      });

      alert.onDidDismiss(() => {
        this.is_alert = false;
      });

      this.is_alert = true;
      alert.present();
    }
  }


  formatDataType(label: string, value: any): string {
    // We check for the udf using the label and convert dataType.name values from udf to label
    for (let property of this.reportProperties) {
      if (property.label == label) {
        for (let dataType of this.dataTypes) {
          if (dataType.name == property.propertyName) {
            dataType.name = property.label;
          }
        }
      }
    }
    return this.formatDataTypePipe.transform(label, value, this.dataTypes);
  }

  goToAppConfig() {
    let returnNavParams = {};
    returnNavParams[NAV_PARAM_RETURN_PAGE] = RETURN_PAGE_CHANGE_STATUS;
    this.navCtrl.push(AppConfigPage, returnNavParams);
  }

  switchStatus(status: ProductStatus) {
    // Initialize loading dialog
    this.loading = this.loadingCtrl.create({
      content: 'Changing Status'
    });
    this.loading.present();
    this.is_loading = true;

    this.currentStatus = status;
    this.initPopover(this.currentStatus);

    // Patch thing
    let body: PatchThingRequestItem[] = [];
    let requestItem = new PatchThingRequestItem();

    requestItem.timestamp = this._vizixService.vizixTime();
    requestItem.serialNumber = this.currentTag;
    requestItem.group = this._vizixService.configurationApp.AppParametersConfiguration.Group.value;
    requestItem.thingTypeCode = this.thingTypeCode;
    requestItem.udfs = {};
    requestItem.udfs[this.itemStatusUDF] = {'value': this.currentStatus.serialNumber};
    requestItem.udfs[this._vizixService.configurationApp.AppParametersConfiguration.ItemEventUDF.value] = {'value': ITEM_EVENT_CHANGE_STATUS};
    requestItem.udfs[ITEM_UDF_USER] = {value: this.username};
    requestItem.udfs[ITEM_UDF_UUID_MOBILE] = {value: this.uuid};
    requestItem.udfs[ITEM_UDF_SOURCE] = {value: VIZIX_THING_ITEM_UDF_SOURCE};
    requestItem.udfs[ITEM_UDF_CATEGORY] = {value: 'Workflow'};
    requestItem.udfs[ITEM_UDF_SUB_CATEGORY] = {value: 'Change Status'};
    requestItem.udfs[ITEM_UDF_ACTIVITY] = {value: 'Change Status'};

    // Now add also the default values from the data entry
    for (let reportEntryProperty of this.reportEntryPropertyList) {
      if (!reportEntryProperty.editInline && reportEntryProperty.defaultMobileValue) {
        requestItem.udfs[reportEntryProperty.propertyName] = {'value': reportEntryProperty.defaultMobileValue};
      }
    }

    body.push(requestItem);

    console.log(this.tag, 'request body:');
    console.log(this.tag, body);

    this._vizixService.VizixPatchItem(body).subscribe(
      (data: any) => {
        console.log(this.tag, data);
        this.showSuccessAlert();

        this.saveChangeStatusEvent(this.currentTag, this.currentStatus);
      },
      (err) => {
        console.log(this.tag, 'error' + err);
        this.showErrorAlert();
      },
      () => {
        this.dismissLoading();
      }
    )
    ;
  }

  saveChangeStatusEvent(tag: string, status: ProductStatus, isError?: boolean, errorMessage?: string) {
    this.vizixEventService.getVizixEventItemBase().then((vizixEvent) => {
      vizixEvent.category = VizixEventCategory.WORKFLOW;
      vizixEvent.subCategory = VizixEventSubCategory.CHANGE_STATUS;
      vizixEvent.eventType = VizixEventEventType.INFO;
      vizixEvent.activity = VizixEventActivity.CHANGE_STATUS;

      let message = {
        tag: tag,
        statusName: status.name,
        statusSerial: status.serialNumber
      };

      if (isError) {
        vizixEvent.detail = this.vizixEventService.generateDetailsMessage(errorMessage,
          this.thingTypeCode, this.thingTypeCodeGroup);
      } else {
        vizixEvent.detail = this.vizixEventService.generateDetailsMessage(message,
          this.thingTypeCode, this.thingTypeCodeGroup);
      }

      vizixEvent.count = 1;
      vizixEvent.eventId = VIZIX_EVENT_ID_CHANGE_STATUS;
      this.vizixEventService.recordEvent(vizixEvent);
    }, (error) => {
      console.log(this.tag, 'Error getting VizixItemBase', error);
    });
  }

  public updateThingTypeCodeGroup() {
    this._vizixService.VizixGetThingTypeGroup(this.thingTypeCode).subscribe((group) => {
      console.log(this.tag, 'Updated thingTypeCodeToSync group', group);
      this.thingTypeCodeGroup = group;
    }, (error) => {
      console.log(this.tag, 'Error updating thingTypeCodeToSync group', error);
    });
  }

  clearScreen(clearText: boolean, clearScreen: boolean) {
    if (clearText) {
      this.currentTag = "";
    }

    if (clearScreen) {
      this.dataFields = [];
      if (this.is_loading && this.loading) {
        this.loading.dismiss();
        this.is_loading = false;
      }
    }
    this.cdr.detectChanges();
  }

  goBack() {
    if (!this.is_loading && !this.is_alert && !this.isPopActive) {

      if (this.popover) {
        this.popover.dismiss();
      }

      this.isPopActive = true;
      this.navCtrl.pop();
    }
  }

  onChangeKeyValue(event) {
    let charPressed = event.charAt(event.length - 1);
    if (!charPressed) {
      charPressed = '';
    }
    let regExpression = new RegExp(this.validationExpRegTagWithoutQuantifiers);
    if (!regExpression.test(<string>charPressed.toUpperCase())) {
      this.currentTag = event.replace(charPressed, '');
      this.inputTagField.value = this.currentTag;
    }
    else {
      this.currentTag = event;
    }
    this.cdr.detectChanges();
  }
}



// WEBPACK FOOTER //
// ./src/pages/change-status/change-status.ts